export const RELEASE_FLOW_STEPS = {
  RELEASE_DESTINATION: "RELEASE_DESTINATION",
  RELEASE_VERSION_MANAGEMENT: "RELEASE_VERSION_MANAGEMENT",
};

export const TYPES = {
  OPEN: "OPEN",
  CLOSE: "CLOSE",
  GO_TO_VERSION_MANAGEMENT: "GO_TO_VERSION_MANAGEMENT",
  GO_BACK_TO_DESTINATION: "GO_BACK_TO_DESTINATION",
  TOGGLE_DESTINATION: "TOGGLE_DESTINATION",
  TOGGLE_ALL_DESTINATIONS: "TOGGLE_ALL_DESTINATIONS",
  TOGGLE_KEEP_VERSION: "TOGGLE_KEEP_VERSION",
  TOGGLE_KEEP_ALL_VERSIONS: "TOGGLE_KEEP_ALL_VERSIONS",
  SET_OBSERVATION_ENABLED: "SET_OBSERVATION_ENABLED",
  SET_OBSERVATION_TEXT: "SET_OBSERVATION_TEXT",
  SET_SUBMITTING: "SET_SUBMITTING",
};
